var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-row', {
    staticClass: "mb-2"
  }, [_vm.validaRole(['Administrator', 'Developer', 'Director']) ? _c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "lg": "3"
    }
  }, [_c('b-link', {
    attrs: {
      "to": "/ProfessorLista"
    }
  }, [_c('b-card', {
    staticClass: "h-100"
  }, [_c('div', {
    staticClass: "img-componente"
  }, [_c('img', {
    attrs: {
      "src": "/assets/images/componentes/1-prof.png"
    }
  }), _c('h4', [_vm._v("Professores")])])])], 1)], 1) : _vm._e(), _vm.validaRole(['Administrator', 'Developer']) ? _c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "lg": "3"
    }
  }, [_c('b-link', {
    attrs: {
      "to": "/EscolasLista"
    }
  }, [_c('b-card', {
    staticClass: "h-100",
    attrs: {
      "to": "/ProfessorLista"
    }
  }, [_c('div', {
    staticClass: "img-componente"
  }, [_c('img', {
    attrs: {
      "src": "/assets/images/componentes/2-escola.png"
    }
  }), _c('h4', [_vm._v("Escolas")])])])], 1)], 1) : _vm._e(), _vm.validaRole(['Administrator', 'Developer', 'Professor']) ? _c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "lg": "3"
    }
  }, [_c('b-link', {
    attrs: {
      "to": "/todosdesafios"
    }
  }, [_c('b-card', {
    staticClass: "h-100"
  }, [_c('div', {
    staticClass: "img-componente"
  }, [_c('img', {
    attrs: {
      "src": "/assets/images/componentes/4-desafios.png"
    }
  }), _c('h4', [_vm._v("Desafios")])])])], 1)], 1) : _vm._e(), _vm.validaRole(['Administrator', 'Developer', 'Professor']) ? _c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "lg": "3"
    }
  }, [_c('b-link', {
    attrs: {
      "to": "/Alunos"
    }
  }, [_c('b-card', {
    staticClass: "h-100"
  }, [_c('div', {
    staticClass: "img-componente"
  }, [_c('img', {
    attrs: {
      "src": "/assets/images/componentes/3-jovem.png"
    }
  }), _c('h4', [_vm._v("Alunos")])])])], 1)], 1) : _vm._e(), _vm.validaRole(['Administrator', 'Developer']) ? _c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "lg": "3"
    }
  }, [_c('b-link', {
    attrs: {
      "to": "/ColetaDadosCampo"
    }
  }, [_c('b-card', {
    staticClass: "h-100"
  }, [_c('div', {
    staticClass: "img-componente"
  }, [_c('img', {
    attrs: {
      "src": "/assets/images/componentes/7-pesquisador.png"
    }
  }), _c('h4', [_vm._v("Coleta de Dados")])])])], 1)], 1) : _vm._e()], 1), _c('b-row')], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }